import { render, staticRenderFns } from "./interactive-input.vue?vue&type=template&id=1bf3d9e8&scoped=true&"
import script from "./interactive-input.vue?vue&type=script&lang=js&"
export * from "./interactive-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf3d9e8",
  null
  
)

export default component.exports